import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { DocumentExtractionCategoryInfo } from '../../../models/DocumentExtraction/document-extraction-category-info';

export const GetDocumentExtractionCategories = createAsyncThunk(
    'documentExtraction/getCategories',
    async (_: void, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get('/api/DocumentExtraction/categories');
        if (response.status !== 200) {
            createNotification(
                'Could not load document extraction settings.',
                'error'
            );
            throw new Error('Failed to fetch document extraction categories');
        }
        return response.data as DocumentExtractionCategoryInfo[];
    }
);
